import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e51a6bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-bs-title"]
const _hoisted_2 = ["data-bs-title"]
const _hoisted_3 = ["data-bs-title"]
const _hoisted_4 = ["data-bs-title"]
const _hoisted_5 = ["data-bs-title"]
const _hoisted_6 = ["data-bs-title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isDpUser && _ctx.customDesignTemplate)
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: _normalizeClass([_ctx.iconClass, "mas text-danger ms-1 mb-1"]),
          "data-bs-toggle": "tooltip",
          "data-bs-placement": "top",
          "data-bs-title": _ctx.customDesignTemplate?.description
        }, "edit_document", 10, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.isLocked)
      ? (_openBlock(), _createElementBlock("i", {
          key: 1,
          class: _normalizeClass([_ctx.iconClass, "mas text-danger ms-1 mb-1"]),
          "data-bs-toggle": "tooltip",
          "data-bs-html": "true",
          "data-bs-placement": "top",
          "data-bs-title": _ctx.lockedText
        }, "lock", 10, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.hasEyebrow)
      ? (_openBlock(), _createElementBlock("i", {
          key: 2,
          class: _normalizeClass([_ctx.iconClass, "mas text-primary ms-1 mb-1"]),
          "data-bs-toggle": "tooltip",
          "data-bs-placement": "top",
          "data-bs-title": _ctx.$t('cms.eyebrow')
        }, "title", 10, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.hasBorder)
      ? (_openBlock(), _createElementBlock("i", {
          key: 3,
          class: _normalizeClass([_ctx.iconClass, "mas text-primary ms-1 mb-1"]),
          "data-bs-toggle": "tooltip",
          "data-bs-placement": "top",
          "data-bs-title": _ctx.$t('cms.border')
        }, "border_style", 10, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.hasBoxShadow)
      ? (_openBlock(), _createElementBlock("i", {
          key: 4,
          class: _normalizeClass([_ctx.iconClass, "mas text-primary ms-1 mb-1"]),
          "data-bs-toggle": "tooltip",
          "data-bs-placement": "top",
          "data-bs-title": _ctx.$t('cms.boxShadow')
        }, "shadow", 10, _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.hasOverlays)
      ? (_openBlock(), _createElementBlock("i", {
          key: 5,
          class: _normalizeClass([_ctx.iconClass, "mas text-primary ms-1 mb-1"]),
          "data-bs-toggle": "tooltip",
          "data-bs-placement": "top",
          "data-bs-title": _ctx.$t('cms.overlays')
        }, "layers", 10, _hoisted_6))
      : _createCommentVNode("", true)
  ], 64))
}